<script setup lang="ts">
</script>

<template>
  <div class="toc-design-content container-fluid">
    <slot></slot>
  </div>
</template>

<style scoped>
.toc-design-content {
  height: 100%;
  overflow-y: auto;
  padding: 0 calc(var(--bs-gutter-x) * .5);

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>